export const firebaseConfig = {
  apiKey: process.env.REACT_APP_AUTH_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_AUTH_FIREBASE_AUTHDOMAIN,
  clientId: process.env.REACT_APP_AUTH_OAUTH_CLIENT_ID,
}
